import { Button, Radio, RadioChangeEvent, Space } from "antd";
import { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import BackButtonIcon from "../../../assets/icons/BackButtonIcon";
import PrintIcon from "../../../assets/icons/PrintIcon";
import InfoItem from "../../../components/common/InfoItem";
import TopCard from "../../../components/common/TopCard";
import ProfileImage from "../../../components/ProfileImage";
import ConfirmModal from "../../../components/ui/ConfirmModal";
import Loader from "../../../components/ui/Loader";
import { AdditionDeductionType } from "../../../features/emp-setting/employee/employee.type";
import {
  useDeleteInvitedMutation,
  useGetPayrollSettingQuery,
  useLazyDownloadEmployeeDetailsQuery,
  useReInvitedMutation,
} from "../../../features/emp-setting/employee/employeeApi";
import {
  useGetSingleUserQuery,
  useUpdateUserStatusMutation,
} from "../../../features/portal/user/userApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { toast } from "../../../lib/toast";
import { EmployeeStatusType } from "../../../types";
import { capitalize } from "../../../utils/string";
import { underscoreToCapitalizeString } from "../../../utils/utils";
import NotFound from "../../NotFound";
import ActivityLog from "./_components/view/ActivityLog";
import EmergencyInfo from "./_components/view/EmergencyInfo";
import FinancialInfo from "./_components/view/FinancialInfo";
import InvitedEmployeeActive from "./_components/view/InvitedEmployeeActive";
import OfficialInfo from "./_components/view/OfficialInfo";
import PersonalInfo from "./_components/view/PersonalInfo";
import UserAccessPermission from "./_components/view/UserAccessPermission";

const statusList: EmployeeStatusType[] = ["active", "inactive"];

export const employeeDetailsList = [
  "Official",
  "Personal",
  "Financial",
  // "Salary",
  "Emergency",
  // "Additional Information",
  // "Activity Log",
  "User Access Permission",
] as const;

type ItemType = (typeof employeeDetailsList)[number];
type ModalType =
  | "CONFIRM"
  | "SEND_INVITATION_AGAIN"
  | "DELETE_INVITE"
  | "ACTIVE_INVITED_EMPLOYEE";

export const useEmployeeProfile = (viewId: string) => {
  let [queryParams, setSearchParams] = useSearchParams();
  const [item, setItem] = useState<ItemType | number | "ActivityLog">(
    "Official"
  );
  // const {
  //   isLoading: isAdditionalLoading,
  //   isError: isAdditionalError,
  //   error: additionalError,
  //   data: additionalData,
  // } = useGetAdditionalDataQuery({});
  const { isError, error, data, isLoading } = useGetSingleUserQuery(
    viewId || "",
    {
      skip: !viewId,
    }
  );
  // const { isLoading: isSalaryLoading, data: salaryData } =
  //   useGetEmployeeBreakdownSalaryDetailsQuery(viewId || "", {
  //     skip: !viewId || item !== "Salary",
  //   });
  // const {
  //   isLoading: isComponentSettingLoading,
  //   isError: isComponentSettingError,
  //   error: componentSettingError,
  //   data: componentSettingData,
  // } = useGetPayComponentSettingQuery(
  //   { params: { business_member_id: Number(viewId) } },
  //   {
  //     skip: !viewId || item !== "Salary",
  //   }
  // );

  useError(isError, error, "Get employee data fail");
  // const componentDetails = componentSettingData?.data?.pay_components;
  // useError(isAdditionalError, additionalError, "Get additional data fail");
  // useError(
  //   isComponentSettingError,
  //   componentSettingError,
  //   "Get additions and deductions data fail"
  // );

  const employeeDetails = data?.data;

  function getInfoData() {
    if (item === "Official") {
      return <OfficialInfo data={data} />;
    } else if (item === "Personal") {
      return <PersonalInfo data={data} />;
    } else if (item === "Financial") {
      return <FinancialInfo data={data} />;
    }

    // else if (item === "Salary") {
    //   return <SalaryInfo showEditButton={data?.data?.status === "invited"} />;
    // }
    else if (item === "Emergency") {
      return <EmergencyInfo data={data} />;
    } else if (item === "ActivityLog") {
      return <ActivityLog />;
    }

    // else if (checkAddition(item)) {
    //   return <AdditionalInformation data={data} />;
    // }
    else if (item === "User Access Permission") {
      return <UserAccessPermission data={data} />;
    } else {
      return undefined;
    }

    // function checkAddition(value: ItemType | number) {
    //   const itemData = Number(value);
    //   return !isNaN(itemData);
    // }
  }

  useEffect(() => {
    if (queryParams.get("type")) {
      setItem(queryParams.get("type") as ItemType);
    }
  }, [queryParams]);

  return {
    error,
    isLoading,
    employeeDetails,
    employeeDetailsList,
    setItem,
    queryParams,
    setSearchParams,
    item,
    // isAdditionalLoading,
    // additionalData,
    getInfoData,
    // isComponentSettingLoading,
    // componentDetails,
    // isSalaryLoading,
    // salaryData,
    data,
  };
};

export default function EmployeesDetails() {
  const { viewId } = useParams();
  const navigate = useNavigate();
  // const location = useLocation();
  const {
    error,
    isLoading,
    employeeDetails,
    employeeDetailsList,
    setItem,
    setSearchParams,
    item,
    // isAdditionalLoading,
    // additionalData,
    getInfoData,
    // isComponentSettingLoading,
    // componentDetails,
    // isSalaryLoading,
    // salaryData,
    data,
  } = useEmployeeProfile(String(viewId));
  // console.log(employeeDetails?.email);
  const [status, setStatus] = useState<EmployeeStatusType | undefined>(
    undefined
  );
  const { open, handleOpen, handleClose } = useModal<undefined, ModalType>();
  // const [
  //   updateEmployeeStatus,
  //   {
  //     isLoading: isUpdateLoading,
  //     isError: isUpdateStatusError,
  //     error: updateStatusError,
  //     isSuccess: isUpdateStatusSuccess,
  //   },
  // ] = useUpdateEmployeeStatusMutation();
  const [
    deleteInvited,
    {
      isError: isDeleteError,
      error: deleteError,
      isSuccess: isDeleteSuccess,
      isLoading: isDeleteLoading,
    },
  ] = useDeleteInvitedMutation();
  const [
    reInvited,
    {
      isError: isReInviteError,
      error: reInviteError,
      isSuccess: isReInviteSuccess,
      isLoading: isReInviteLoading,
    },
  ] = useReInvitedMutation();

  const [downloadEmployeeDetails, { isLoading: isDownloading, data: pdfUrl }] =
    useLazyDownloadEmployeeDetailsQuery();
  // useError(
  //   isUpdateStatusError,
  //   updateStatusError,
  //   "Employee update status fail"
  // );
  useError(isDeleteError, deleteError, "Employee delete fail");
  useError(isReInviteError, reInviteError, "Re-invitation mail sent fail");
  const [
    updateUserStatus,
    {
      isError: updateUserStatusIsError,
      error: updateUserStatusError,
      isSuccess: updateUserStatusIsSuccess,
      isLoading: updateUserStatusIsLoading,
    },
  ] = useUpdateUserStatusMutation();
  useError(
    updateUserStatusIsError,
    updateUserStatusError,
    "update user status failed"
  );

  const handleStatus = (e: RadioChangeEvent) => {
    if (employeeDetails?.status !== e.target.value) {
      handleOpen({ type: "CONFIRM", data: e.target.value });
    }
  };

  const handleConfirm = (val?: EmployeeStatusType) => {
    if (viewId && val) {
      updateUserStatus({
        email: employeeDetails?.email,
        enabled: val === "active",
      });
      // updateEmployeeStatus({
      //   body: {
      //     status: val,
      //   },
      //   id: viewId,
      // });
    }
  };

  const handleSandInvitationAgain = (): void => {
    reInvited({
      id: Number(viewId),
      body: {
        email: employeeDetails?.email,
        profile_id: employeeDetails?.member?.profile?.id,
      },
    });
  };

  const handleDownloadEmployeeDetails = () => {
    downloadEmployeeDetails({ id: data?.data?.id });
  };

  useEffect(() => {
    if (pdfUrl) {
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "co_worker_details.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [pdfUrl]);

  useEffect(() => {
    if (employeeDetails?.status) {
      setStatus(employeeDetails?.status);
    }
  }, [employeeDetails?.status]);

  // useEffect(() => {
  //   if (isUpdateStatusSuccess) {
  //     toast("success", "Status updated successfully");
  //     handleClose();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isUpdateStatusSuccess]);

  useEffect(() => {
    if (isReInviteSuccess) {
      toast("success", "Re-invitation mail sent successfully");
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReInviteSuccess]);

  useEffect(() => {
    if (isDeleteSuccess) {
      toast("success", "Employee deleted successfully");
      handleClose();
      navigate("/admin/employees");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteSuccess]);

  useEffect(() => {
    if (updateUserStatusIsSuccess) {
      toast("success", "Status updated successfully");
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateUserStatusIsSuccess]);

  if (error && "status" in error && error.status === 404) {
    return <NotFound title="Sorry, data not found" />;
  }

  return (
    <SidebarLayout title="Employee Details">
      {open?.type === "CONFIRM" && (
        <ConfirmModal
          open={open?.open}
          handleOk={() => handleConfirm(open?.data)}
          handleClose={handleClose}
          okText="Confirm"
          confirmTitle={`${capitalize(open?.data || "")} User.`}
          questionText={`Are you sure you want to ${open?.data} this user?`}
          okLoading={updateUserStatusIsLoading}
        />
      )}

      {open?.type === "SEND_INVITATION_AGAIN" && (
        <ConfirmModal
          open={open.open}
          handleClose={handleClose}
          handleOk={handleSandInvitationAgain}
          confirmTitle="Confirmation"
          questionText="Are you sure you want send invitation mail again?"
          okText="Send"
          okLoading={isReInviteLoading}
        />
      )}
      {open?.type === "DELETE_INVITE" && (
        <ConfirmModal
          open={open.open}
          handleClose={handleClose}
          handleOk={() => deleteInvited(Number(viewId))}
          confirmTitle="Confirmation"
          questionText="Are you sure you want to delete?"
          okText="Yes"
          cancelText="No"
          okLoading={isDeleteLoading}
        />
      )}

      {open?.type === "ACTIVE_INVITED_EMPLOYEE" && (
        <InvitedEmployeeActive open={open?.open} handleClose={handleClose} />
      )}

      {isLoading ? (
        <Loader />
      ) : (
        <>
          <TopCard
            size={16}
            align="center"
            leftChildren={
              <Button
                className="normal-dark-button"
                icon={<BackButtonIcon />}
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            }
          >
            {/* <div className="flex items-center gap-4">
                <div className="w-14 h-14">
                  <img
                    className="w-full h-full rounded-full"
                    src={employeeDetails?.member?.profile?.pro_pic || UserImg}
                    alt=""
                  />
                </div>
                <div className="flex flex-col gap-0.5">
                  <h3 className="text-body text-lg font-semibold leading-normal">
                    {employeeDetails?.member?.profile?.name}
                  </h3>

                  <p className="text-body-text text-sm font-medium leading-normal">
                    {employeeDetails?.role?.name}
                  </p>
                </div>
              </div> */}
            {employeeDetails?.status === "invited" ||
            employeeDetails?.is_account_hold ? (
              <Space size={16}>
                <Button
                  className="download-button"
                  onClick={() =>
                    handleOpen({ type: "ACTIVE_INVITED_EMPLOYEE" })
                  }
                >
                  Activate
                </Button>
                <Button
                  type="primary"
                  className="!bg-[#001652] sm-button !px-3"
                  onClick={() => handleOpen({ type: "SEND_INVITATION_AGAIN" })}
                >
                  Invite again
                </Button>
                <Button
                  className="delete-button"
                  onClick={() => handleOpen({ type: "DELETE_INVITE" })}
                >
                  Delete
                </Button>
              </Space>
            ) : (
              <>
                <Radio.Group
                  value={status}
                  className="custom-radio success-radio"
                  size="large"
                  onChange={handleStatus}
                >
                  {statusList?.map((el, idx) => (
                    <Radio
                      className="text-header text-base font-medium leading-7 mr-3.5 cursor-pointer"
                      value={el}
                      key={idx}
                    >
                      {capitalize(el)}
                    </Radio>
                  ))}
                </Radio.Group>
                <Button
                  loading={isDownloading}
                  className="middle-button normal-dark-button"
                  icon={<PrintIcon />}
                  // onClick={downloadPDF}
                  onClick={handleDownloadEmployeeDetails}
                />
              </>
            )}

            {/* <Button
              type="primary"
              className="middle-button"
              icon={<SettingIcon />}
            /> */}
          </TopCard>

          <div className="bg-white rounded-md grid md:grid-cols-4">
            <ul className="p-4 border-r border-extra-light">
              <li className="flex items-center gap-4 mb-4">
                {/* // GS-4 Start */}
                <ProfileImage
                  rootClass="!w-14 !h-14"
                  className="!text-xl"
                  img={employeeDetails?.photo}
                  name={employeeDetails?.name}
                />
                {/* // GS-4 End */}
                <div className="flex flex-col gap-0.5">
                  <h3 className="text-body text-lg font-semibold leading-normal">
                    {employeeDetails?.name}
                  </h3>

                  <p className="text-body-text text-sm font-medium leading-normal">
                    {employeeDetails?.sub_department?.name}
                  </p>
                </div>
              </li>

              {employeeDetailsList?.map((el) => (
                <li
                  key={el}
                  onClick={() => {
                    setItem(el);
                    setSearchParams({ type: el });
                  }}
                  className={`font-medium h-10 px-3 rounded-lg flex items-center cursor-pointer ${
                    el === item ? "bg-[#fff1eb]/50 text-primary" : "text-muted"
                  }`}
                >
                  {el}
                </li>
              ))}
              {/* {isAdditionalLoading ? (
                <li className="text-center py-1 text-body">Loading...</li>
              ) : (
                additionalData?.data?.additionalSections?.map((el, index) => (
                  <li
                    key={el?.id}
                    onClick={() => {
                      setItem(el?.id);
                      setSearchParams({ type: el?.id?.toString() });
                    }}
                    className={`font-medium h-10 px-3 rounded-lg flex items-center cursor-pointer ${
                      item?.toString() === el?.id?.toString()
                        ? "bg-[#fff1eb]/50 text-primary"
                        : "text-muted"
                    }`}
                  >
                    {el?.label}
                  </li>
                ))
              )} */}

              {/* GS-4 start */}
              {/* <li
                onClick={() => {
                  setItem("ActivityLog");
                  setSearchParams({ type: "ActivityLog" });
                }}
                className={`font-medium h-10 px-3 rounded-lg flex items-center cursor-pointer ${
                  item?.toString() === "ActivityLog"
                    ? "bg-[#fff1eb]/50 text-primary"
                    : "text-muted"
                }`}
              >
                Activity Log
              </li> */}
              {/* GS-4 end */}
            </ul>
            <div className="md:col-span-3 p-4">{getInfoData()}</div>
          </div>
          {/* {item !== "Salary" ? null : isComponentSettingLoading ? (
            <div className="py-4">
              <Loader />
            </div>
          ) : !componentDetails?.addition?.length &&
            !componentDetails?.deduction?.length ? null : (
            <div className="bg-white rounded-md mt-6 p-4">
              <div className="grid sm:grid-cols-2 gap-10">
                <div>
                  <h5 className="text-header font-semibold text-xl mb-3">
                    Addition Details
                  </h5>
                  {componentDetails?.addition?.length ? (
                    componentDetails?.addition?.map((item, idx) => (
                      <ComponentDetails
                        item={item}
                        index={idx}
                        key={item?.id}
                      />
                    ))
                  ) : (
                    <div>
                      <CustomEmpty rootClassName="py-20" />
                    </div>
                  )}
                </div>
                <div>
                  <h5 className="text-header font-semibold text-xl mb-3">
                    Deduction Details
                  </h5>
                  {componentDetails?.deduction?.length ? (
                    componentDetails?.deduction?.map((item, idx) => (
                      <ComponentDetails
                        item={item}
                        index={idx}
                        key={item?.id}
                      />
                    ))
                  ) : (
                    <div>
                      <CustomEmpty rootClassName="py-20" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {item !== "Salary" ? null : isSalaryLoading ? (
            <div className="py-4">
              <Loader />
            </div>
          ) : salaryData?.data?.salary_info?.gross_salary_log?.length ? (
            <div className="bg-white rounded-md mt-6 p-4 pb-0">
              <h5 className="text-header font-semibold text-xl mb-3">
                Salary Logs
              </h5>
              <ul>
                {salaryData?.data?.salary_info?.gross_salary_log?.map((log) => (
                  <InfoItem
                    title={`${formatTime(log?.created_at)} - ${formatDate(
                      log?.created_at
                    )}`}
                    key={log?.id}
                  >
                    {log?.log}
                  </InfoItem>
                ))}
              </ul>
            </div>
          ) : null} */}
        </>
      )}

      {/* <PrintableContent ref={currentRef}>
        <EmployeeDetailsPDF />
      </PrintableContent> */}
    </SidebarLayout>
  );
}

export const ComponentDetails = ({
  item,
  index,
}: {
  item: AdditionDeductionType;
  index: number;
}) => {
  const [sData, setSData] = useState<any>();
  const { data: salaryData, isError, error } = useGetPayrollSettingQuery();
  useError(isError, error, "Get salary breakdown data fail");

  useEffect(() => {
    if (salaryData) {
      setSData([
        ...(typeListCalculationSelect || []),
        ...(salaryData?.data?.payroll_setting?.salary_breakdown
          ?.filter((item) => item?.is_active)
          ?.map((item) => ({
            label: `% of ${item?.title}`,
            value: item?.id?.toString(),
          })) || []),
      ]);
    }
  }, [salaryData]);

  const componentType = (on_what: string) =>
    sData?.find((el: any) => el?.value === on_what)?.label;

  return (
    <div className="mb-5 last:mb-0">
      <h4 className="text-header font-semibold text-sm">Item {index + 1}:</h4>
      <ul className="ml-5">
        <InfoItem title="Component Title">{item?.value}</InfoItem>
        {item?.packages?.map((pkg, pkgIndex) => (
          <Fragment key={pkg?.id}>
            <li>
              <h4 className="text-header font-semibold text-xs pt-2">
                #{pkgIndex + 1}
              </h4>
            </li>
            <InfoItem rootClassName="pt-1" title="Package Name">
              {pkg?.name}
            </InfoItem>
            <InfoItem rootClassName="pt-1" title="Component Type">
              {componentType(pkg?.on_what)}
            </InfoItem>
            <InfoItem rootClassName="pt-1" title="Component Value">
              {`${
                pkg?.on_what === "fixed_amount"
                  ? pkg?.amount
                  : `${Number(pkg?.amount)}%`
              }`}
            </InfoItem>
            <InfoItem rootClassName="pt-1" title="Come from">
              {underscoreToCapitalizeString(pkg?.effective_for)}
            </InfoItem>
          </Fragment>
        ))}
      </ul>
    </div>
  );
};

export const typeListCalculationSelect = [
  { label: "Fixed Amount", value: "fixed_amount" },
  { label: "% of Gross Salary", value: "gross_salary" },
  // { label: "% of Basic Salary", value: "basic_alary" },
  // { label: "% of House Rent", value: "house_rent" },
  // { label: "% of Medical Allowance", value: "medical_allowance" },
  // { label: "% of Conveyance", value: "conveyance" },
];
